import { useAuth } from "../../shared/auth/AuthContext";

/**
 * Determines if the current user can create new games.
 *
 * A user can create games if:
 * - They have the "superuser" role, OR
 * - They have the "canCreateGames" permission set to true
 */
export default function useCanCreateGames(): boolean {
  const { canCreateGames } = useAuth();
  return canCreateGames;
}
